import React, {PureComponent as Component} from 'react';
import {MCbrowser} from "../../../Context/browserContext";
import {ChevronLeft} from "react-feather";
import {Link} from "react-router-dom";
import GetGalleryPicDataTableApi from "./Api/GetDataTableApi";

class   ShowPictursBox  extends Component{

    constructor(props) {
        super(props);
        this.isAlive = true;
        this.galleryBox=null;
        this.state = {loaded: false,isClose:false};
        this.props=props;
    }


    componentDidMount() {
        this.getLoad();
    }

    async getLoad() {
        let data = await GetGalleryPicDataTableApi();
        if (data === false) {
            this.setState({loaded: true,isClose:true});
        } else {

            let i=0;
            let s1;
            let r1=[];
            let r2=[];
            let r3=[];
            for (i=0;i<data.length;i++){
                s1='http://mdyaran.ir/membership/gallery/'+data[i].id+'.'+data[i].fileType;
                let el= <img  key={data[i].id} className="img-fluid lazyload blur-up"
                              data-src={s1}   src="/images/default.png"  alt=""/>;
                if(i<3){r1.push(el);}
                if(i>=3 && i<6){r2.push(el);}
                if(i>=6 && i<9){r3.push(el);}
            }

            this.galleryBox=<div className="gallery-box-main">
                <div className="gallery-box">{r1}</div>
                <div className="gallery-box">{r2}</div>
                <div className="gallery-box">{r3}</div>
            </div>;
            this.setState({loaded: true});
        }
    }

    render() {

        return (
            <>
                <div className="box shadow-sm border rounded bg-white mb-3">
                    <div className="box-title border-bottom p-3 d-flex align-items-center">
                        <h6 className="m-0">
                            تصاویر
                        </h6>
                        <Link className="mr-auto" to="/membership/gallery">
                            نمایش همه
                            <ChevronLeft size={16} />
                        </Link>
                    </div>
                    <div className="box-body p-3"> {this.galleryBox} </div>
                </div>
            </>
        ); 
  }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

ShowPictursBox.contextType = MCbrowser;

export default ShowPictursBox;
